import {newId} from  "./util.js";

export class RadioButtons {

    constructor(name, settings, items) {
        let defaults = {
            onSelect: (value) => {},
            minWidth: '0'
        };

        this.set = Object.extend(true, defaults, settings);

        this.elMain = HTMLElement.createFromHTML(
            '<div class="radio-buttons">'
          + '</div>'
        );

        if (items) {
            for (let item of items) {
                let id = newId();
                this.elMain.createElement('input', "", { type: 'radio', name: name, id: id, value: item.value });
                let label = this.elMain.createElement('label', "", { for: id });
                label.innerHTML = item.label;
                label.style.minWidth = this.set.minWidth;
            }
        }

        this.elMain.querySelectorAll('input').forEach(input => {
            input.onclick = () => {
                this.set.onSelect(this.getValue());
            }
        });
   
    }

    getValue() {
        const elSelected = this.elMain.querySelector('input:checked')
        return elSelected ? elSelected.value : false;
    }

    setValue(value, update=true) {
        let el = this.elMain.querySelector('input[value='+value+']');
        if (el) {
            el.checked = true;
            if (update) this.set.onSelect(this.getValue());
        }
        else {
            toast.alert(value + ' nicht gefunden', { duration: 8000 });
        }
    }

    getElement() {
        return this.elMain;
    }

    setEnabled(enabled) {
        this.elMain.querySelectorAll('input').forEach((elRadio) => elRadio.disabled = !enabled);
        this.elMain.style.opacity = enabled ? 1 : 0.3;
    }


}